module.exports = ".panel .panel-body {\n  line-height: normal; }\n"